import React from "react";
import { Card, Button, Row, Col, Image } from "react-bootstrap";
import { FaTrophy } from "react-icons/fa";
import { IoTrophy } from "react-icons/io5";

interface PrizeCardProps {
	imageUrl?: string | null;
	prizeType: "overall" | "round" | "season";
	brandUrl?: string;
	description: string;
	series: {
		name: string;
	};
	sport: {
		name: string;
	};
	winnerLabel?: string;
	eventName?: string;
}

const PrizeCard: React.FC<PrizeCardProps> = ({
	imageUrl,
	prizeType,
	brandUrl,
	description,
	series,
	sport,
	winnerLabel,
	eventName,
}) => {
	const handleClick = () => {
		if (brandUrl) {
			window.open(brandUrl, "_blank");
		}
	};
	return (
		<Card
			className="h-100"
			bg="transparent"
			border="0"
			style={{ maxWidth: "15rem" }}
		>
			<Card.Body className="d-flex flex-column">
				{imageUrl && (
					<div className="text-center mb-3">
						<Image
							src={imageUrl}
							fluid
							alt="Prize"
							style={{ width: "12rem", height: "12rem", cursor: "pointer" }}
							onClick={handleClick}
						/>
					</div>
				)}

				<Button
					variant={
						prizeType === "overall" || prizeType === "season"
							? "light"
							: "outline-light"
					}
					className="mb-2 rounded-pill fw-bold align-items-center py-0"
					style={{ width: "fit-content" }}
					size="sm"
				>
					<FaTrophy className="me-1 mb-1" size={15} />
					{prizeType === "round" ? "ROUND PRIZE" : "SEASON PRIZE"}
				</Button>
				<Card.Text className="flex-grow-1 text-light text-start my-0 py-0 fw-bold">
					{description.toLocaleUpperCase()}
					{eventName ? (
						<div className="text-warning fw-normal">
							<small>{eventName}</small>
						</div>
					) : null}
					{winnerLabel ? (
						<div className="text-success fw-normal">
							<small>Winner: {winnerLabel}</small>
						</div>
					) : null}
					<div className="d-flex flex-row text-info fw-normal">
						<small className="me-2">{series.name}</small>
						<small className="">{sport.name}</small>
					</div>
				</Card.Text>
			</Card.Body>
		</Card>
	);
};

export default PrizeCard;
